import React, { useState } from "react";
import { Button, message, AutoComplete } from "antd";
import axios from "axios";
import MyOption from "./Option";

axios.defaults.baseURL = "https://api.wonderbits.cn/var";

const { Option } = AutoComplete;

function SourcePicker(props: any) {
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [fieldName, setFieldName] = useState("");
  const [result, setResult] = useState<string[]>([]);
  const [open, setOpen] = useState(false);

  const handleClickOK = async () => {
    setConfirmLoading(true);
    const response = await axios.get(`/history?name=${fieldName}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    if (response.data.data.length === 0) {
      message.error("没有这个字段的数据!");
    } else {
      //找到字段数据
      let firstBlank = 0;
      let insertCol = -1;
      let filedExist = false;

      //寻找是否已经存在该列
      props.gridSource.forEach((colData: any, index: number) => {
        if (colData[0].value === fieldName) {
          //找到的情况下
          insertCol = index;
          filedExist = true;
        }
      });

      //结束第一次循环后，如果没找到,则寻找第一列空列
      if (!filedExist) {
        let i = 0;
        while (props.gridSource[i][0].value !== "title") {
          i++;
        }
        firstBlank = i;
      }

      insertCol = insertCol === -1 ? firstBlank : insertCol;

      //更新数据
      const newSource = JSON.parse(JSON.stringify(props.gridSource));

      //数据第一列将列名赋值给value
      const targetCol:any = [
        {
          value: fieldName,
          rowIndex: 0,
          colIndex: insertCol,
          readOnly: true,
          disableEvents: true,
        },
      ];

      response.data.data.forEach((value: string, index: number) => {
        targetCol.push({
          value: value,
          rowIndex: index + 1,
          colIndex: insertCol,
        });
      });

      newSource[insertCol] = targetCol;
      props.setGridSource(newSource);

      if (!filedExist) {
        const copy = JSON.parse(JSON.stringify(props.displayColNames));
        copy[insertCol] = newSource[insertCol][0];
        props.setDisplayColNames(copy);
        const copyFilters = JSON.parse(JSON.stringify(props.filterList));
        copyFilters.push({
          col: insertCol,
          filters: [],
        });
        props.setFilterList(copyFilters);
      }
      message.success("数据已完成更新");
    }

    setConfirmLoading(false);
  };

  let lastName = "";
  const onSelect = (data: string) => {
    setOpen(false);
    setFieldName(data);
    lastName = data;
  };
  let lastTime: any;
  const onChange = (data: string) => {
    setFieldName(data);
    const action = async () => {
      if (lastName === data) {
        return;
      }
      if (!data) {
        setResult([]);
      } else {
        lastName = data;
        const response = await axios.get(`/search?name=${data}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        if (response.data.data) {
          setOpen(true);
          setResult(response.data.data);
        }
      }
    };
    if (lastTime === 0) {
      lastTime = setTimeout(() => {
        action();
      }, 1500);
    } else {
      clearTimeout(lastTime);
      lastTime = setTimeout(() => {
        action();
      }, 1500);
    }
  };

  const children = result.map((value: string) => (
    <Option key={value} value={value}>
      <MyOption keyWord={value}></MyOption>
    </Option>
  ));

  return (
    <div style={{ margin: "5px 0px" }}>
      <div style={{ display: "flex", width: 400, margin: "5px 20px" }}>
        <div>
          <AutoComplete
            style={{ width: 200 }}
            onSelect={onSelect}
            onChange={onChange}
            placeholder="输入字段名后点击按钮"
            open={open}
            onBlur={() => {
              setOpen(false);
            }}
          >
            {children}
          </AutoComplete>
        </div>
        <Button
          type="primary"
          onClick={handleClickOK}
          style={{ marginLeft: 10 }}
          loading={confirmLoading}
        >
          {confirmLoading ? "正在获取数据" : "获取数据源"}
        </Button>
      </div>
    </div>
  );
}

export default SourcePicker;
